// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"5efca90e","484":"1674e029","551":"e48e2e00","869":"485ee122","974":"d9d17238"}[chunkId] + ".chunk.js";
};